<template>
  <span
    class="t-tag"
    :class="[
      `t-tag--${type}`,
      { 't-tag--closeable': closeable },
      { 't-tag--soft': soft },
      { 't-tag--small': small },
    ]"
  >
    <span class="t-tag__label">
      <slot></slot>
    </span>
    <a
      v-if="closeable"
      class="t-tag__action"
      @click="close"
      @keyup.delete.prevent="close"
      :disabled="disabled"
    >
      <t-icon icon="times" fixed-width></t-icon>
    </a>
  </span>
</template>

<script>
import ColorTypeMixin from '../../mixins/ColorTypeMixin';
import { TIcon } from '../TIcon';

export default {
  name: 't-tag',
  mixins: [ColorTypeMixin],
  props: {
    soft: Boolean,
    closeable: Boolean,
    disabled: Boolean,
    small: Boolean,
  },
  methods: {
    close(event) {
      if (!this.disabled) {
        this.$emit('close', event);
      }
    },
  },
  components: {
    TIcon,
  },
};
</script>
